import React, { useEffect, useRef } from "react";
import { useDocuments } from "../redux/hooks/useDocuments";
import "../scss/NavBar.scss";
import SidebarBottomFeatures from './SidebarBottomFeatures'

const NavDrawer = ({ isMenuOpen, hideSidebarOnMouseOut, children }) => {
  const { filteredDocuments } = useDocuments();
  const showSidebarBottomFeatures = filteredDocuments.versionData;

  const ref = useRef()

  useEffect(() => {
    const checkIfClickedOutside = e => {
      if (isMenuOpen && ref.current && !ref.current.contains(e.target)) {
        hideSidebarOnMouseOut()
      }
    }

    document.addEventListener("mousedown", checkIfClickedOutside)
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside)
    }
  }, [])

  return (
    <div ref={ref}>
      <div className="sidebar-container">
        <aside className="row">
          {children}
          <span>{showSidebarBottomFeatures ? <SidebarBottomFeatures dialogHost={false} /> : ''}</span>
        </aside>
      </div>
    </div>
  );
}

export default NavDrawer;
